import type {
  QueuesListQueryQueryType,
  QueueJobsListQueryQueryType,
  QueueJobQueryQueryType,
} from "@/types/graphql/admin.generated";

export type QueuesListData = QueuesListQueryQueryType;
export type QueueRow = QueuesListQueryQueryType["queues"]["nodes"][number];
export type QueueJobCounts = QueueRow["jobCounts"];

/**
 * Статусы Bull, по которым раскладываются задачи очереди. Порядок тот же, что
 * в карточке очереди: от «ещё не взяли» к «упало».
 */
export const QUEUE_JOB_STATUSES = [
  "delayed",
  "waiting",
  "active",
  "completed",
  "failed",
] as const;

export type QueueJobStatus = (typeof QUEUE_JOB_STATUSES)[number];

export type QueueJobRow = NonNullable<
  QueueJobsListQueryQueryType["queue"]
>["jobs"]["nodes"][number];

export type QueueJob = NonNullable<QueueJobQueryQueryType["job"]>;
